'use strict';

import { getLiffProfile } from "./LiffService.js";
import { getSecuredFirestore } from "./Firestore.js";

/**
 * Create user and cart documents in Firestore if not exist
 */
async function initProfile() {
  return getLiffProfile().then(function (liffProfile) {
    return getSecuredFirestore().then(function (firestore) {
      let userDoc = firestore.collection('users').doc(liffProfile.userId);
      return userDoc.get().then(async function (doc) {
        let profile;

        if (!doc.exists) {
          profile = {
            name: liffProfile.displayName,
            profilePhoto: liffProfile.pictureUrl,
            languageSource: "line",
            admin: false,
            orderCount: 0
          };
          await userDoc.set(profile);
        } else if (!doc.get('name') || !doc.get('profilePhoto')) {
          profile = {
            name: liffProfile.displayName,
            profilePhoto: liffProfile.pictureUrl,
            admin: doc.get('admin') || false
          };
          await userDoc.update(profile);
        } else {
          profile = doc.data();

          if (!process.env.DEV) {
            // update photo after login, profile phto may be changed
            if (liffProfile.pictureUrl !== profile.profilePhoto) {
              profile.profilePhoto = liffProfile.pictureUrl;
              await userDoc.update({ profilePhoto: liffProfile.pictureUrl });
            }
          }
        }

        // set user id for convenience
        profile.userId = liffProfile.userId;

        let cartsRef = firestore.collection('carts');
        let cartSnapshot = await cartsRef.where('userRef', '==', userDoc).get();
        var cart;
        cartSnapshot.forEach(function (doc) {
          cart = doc.ref;
          return false;
        });

        if (!cart) {
          let cartDoc = cartsRef.doc();
          await cartDoc.set({
            items: [],
            userRef: userDoc,
            addressRef: null,
            deliveryPrice: 0
          });
        }

        return profile;
      });
    });
  });
}

var profilePromise;
async function getProfile() {
  if (profilePromise == null) {
    profilePromise = new Promise(function (resolve, reject) {
      initProfile().then(function (profile) {
        resolve(profile);
      }).catch(function (e) {
        reject(e);
      });
    });
  }
  return profilePromise;
}

function resetProfile() {
  profilePromise = null;
}

export { getProfile, resetProfile };